// src/components/property-availability/property-availability.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query PropertyAvailabilityQuery($context: ContextInput!, $eid: ID!, $dateRange: DateRangeInput) {\n    propertyAvailabilityCalendars(context: $context, eid: $eid, dateRange: $dateRange) {\n      configuration {\n        currentDate {\n          ...DateFragment\n        }\n        beginDate {\n          ...DateFragment\n        }\n        endDate {\n          ...DateFragment\n        }\n        availableByDefault\n        defaultStayConstraints {\n          stayIncrementInDays\n          minimumStayInDays\n          maximumStayInDays\n        }\n        defaultCheckinValidityAfterEndDate\n        defaultCheckoutValidityWhenWithinConstraints\n      }\n      days {\n        ...DayFragment\n      }\n    }\n  }\n\n  fragment DayFragment on AvailabilityCalendarDay {\n    date {\n      ...DateFragment\n    }\n    available\n    stayConstraints {\n      minimumStayInDays\n      maximumStayInDays\n      stayIncrementInDays\n    }\n    checkinValidity\n    checkoutValidity\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React2, { useEffect, useRef, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { parseAvailability } from "@expediagroup/property-availability-parser-v2";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSDateSelector } from "@egds/react-core/date-selector";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
// src/utils/date-helper.ts
var DATE_FORMAT = "yyyy-MM-dd";
var convertDateInputToDate = function(dateInput) {
    return new Date(dateInput.year, dateInput.month - 1, dateInput.day);
};
// src/components/property-availability-day-template/property-availability-day-template.tsx
import React from "react";
import { EGDSAvailabilityBackground, EGDSDateNumber } from "@egds/react-core/calendar";
import { EGDSText } from "@egds/react-core/text";
var canBeSelected = function(dateDayData, day) {
    var _ref = dateDayData || {}, dayIsSelectable = _ref.isSelectable;
    var isPastMaxDate = day.isPastMaxDate;
    return !!dayIsSelectable && !isPastMaxDate;
};
var getAriaLabel = function(dayData, day, l10n) {
    var availability = (dayData || {}).availability;
    var localeDateString = day.localeDateString, isPast = day.isPast;
    if (availability === "available") {
        return localeDateString;
    }
    if (availability === "unavailable" || isPast) {
        return l10n.formatText("hotels.infosite.availability.unavailable.a11yLabel", localeDateString);
    }
    return availability === "am-unavailable" ? l10n.formatText("hotels.infosite.availability.unavailableAm.a11yLabel", localeDateString) : l10n.formatText("hotels.infosite.availability.unavailablePm.a11yLabel", localeDateString);
};
var PropertyAvailabilityDayTemplate = function(props) {
    var day = props.day, dayData = props.dayData;
    var dateDay = day.day, isPast = day.isPast, isPastMaxDate = day.isPastMaxDate, isToday = day.isToday;
    var _ref = dayData || {}, availability = _ref.availability, isSelectable = _ref.isSelectable, rate = _ref.rate;
    var calendarShowRates = Boolean(rate);
    var getAvailability = function() {
        if (isPast || isPastMaxDate) {
            return "available";
        }
        return availability || "unavailable";
    };
    var getTheme = function() {
        if (isToday) {
            return "today";
        }
        if (isPast || isPastMaxDate) {
            return "muted";
        }
        if (isSelectable) {
            return "action";
        }
        return "default";
    };
    return /* @__PURE__ */ React.createElement(EGDSAvailabilityBackground, {
        availability: getAvailability()
    }, /* @__PURE__ */ React.createElement(EGDSDateNumber, {
        theme: getTheme(),
        size: 300,
        weight: "regular",
        disabled: Boolean(isPast) || !isSelectable
    }, dateDay), calendarShowRates && /* @__PURE__ */ React.createElement(EGDSText, null, rate));
};
PropertyAvailabilityDayTemplate.canClick = canBeSelected;
PropertyAvailabilityDayTemplate.canSpan = canBeSelected;
PropertyAvailabilityDayTemplate.getAriaLabel = getAriaLabel;
// src/components/property-availability/property-availability.tsx
var __Query = gql(_templateObject());
var PropertyAvailability = function(props) {
    var _inputs_dateRange, _inputs_dateRange1, _inputs_dateRange2, _inputs_dateRange3;
    var inputs = props.inputs, onSubmit = props.onSubmit, skipSsr = props.skipSsr, startDateRef = props.startDateRef, endDateRef = props.endDateRef, _props_isNestDialog = props.isNestDialog, isNestDialog = _props_isNestDialog === void 0 ? false : _props_isNestDialog;
    var context = useBexApi().context;
    var formatDateString = useLocalization().formatDateString;
    var track = useClickTracker();
    var _useState = _sliced_to_array(useState(((_inputs_dateRange = inputs.dateRange) === null || _inputs_dateRange === void 0 ? void 0 : _inputs_dateRange.start) ? formatDateString(convertDateInputToDate((_inputs_dateRange1 = inputs.dateRange) === null || _inputs_dateRange1 === void 0 ? void 0 : _inputs_dateRange1.start), {
        raw: DATE_FORMAT
    }) : null), 2), checkInDateString = _useState[0], setCheckinDateString = _useState[1];
    var _useState1 = _sliced_to_array(useState(((_inputs_dateRange2 = inputs.dateRange) === null || _inputs_dateRange2 === void 0 ? void 0 : _inputs_dateRange2.end) ? formatDateString(convertDateInputToDate((_inputs_dateRange3 = inputs.dateRange) === null || _inputs_dateRange3 === void 0 ? void 0 : _inputs_dateRange3.end), {
        raw: DATE_FORMAT
    }) : null), 2), checkOutDateString = _useState1[0], setCheckoutDateString = _useState1[1];
    var maxDate = /* @__PURE__ */ new Date().setDate(735);
    var checkInDateRef = useRef(checkInDateString);
    var checkOutDateRef = useRef(checkOutDateString);
    useEffect(function() {
        var _inputs_dateRange, _inputs_dateRange1;
        if (!inputs.dateRange || !((_inputs_dateRange = inputs.dateRange) === null || _inputs_dateRange === void 0 ? void 0 : _inputs_dateRange.start) || !((_inputs_dateRange1 = inputs.dateRange) === null || _inputs_dateRange1 === void 0 ? void 0 : _inputs_dateRange1.end)) {
            setCheckinDateString(null);
            setCheckoutDateString(null);
        }
    }, [
        inputs.dateRange
    ]);
    var _useState2 = _sliced_to_array(useState(true), 2), currentlySelectingCheckInDate = _useState2[0], setCurrentlySelectingCheckInDate = _useState2[1];
    var onDateRangeChange = function(startDate, endDate) {
        setCheckinDateString(startDate);
        setCheckoutDateString(endDate);
        if (startDate && endDate) {
            track("HOT.HIS:ChangeDatesDone", "change dates");
            setCurrentlySelectingCheckInDate(true);
        }
    };
    var onDateRangeClear = function() {
        track("HOT.HIS:ClearDates", "Clear dates");
        setCheckinDateString(null);
        setCheckoutDateString(null);
    };
    var onOpen = React2.useCallback(function() {
        track("HOT.HIS:ChangeDatesCheckIn", "Open calendar");
    }, []);
    var onDateRangeSubmit = function(startDate, endDate) {
        var newStartDate = startDate ? new Date(startDate.replace(/-/g, "/")) : null;
        var newEndDate = endDate ? new Date(endDate.replace(/-/g, "/")) : null;
        checkInDateRef.current = startDate;
        checkOutDateRef.current = endDate;
        if (onSubmit) {
            track("HOT.HIS:SubmitDateChange", "Submit date change");
            onSubmit(newStartDate, newEndDate);
        }
    };
    var onClose = function() {
        var isDatesChanged = checkInDateRef.current !== checkInDateString && checkOutDateRef.current !== checkOutDateString;
        if ((isDatesChanged && checkOutDateString || checkInDateString === null && checkOutDateString === null && isDatesChanged || checkOutDateRef.current !== checkOutDateString && checkOutDateString) && !isNestDialog) {
            onDateRangeSubmit(checkInDateString, checkOutDateString);
        }
    };
    var onSelectionModeChange = function(isEndDate) {
        setCurrentlySelectingCheckInDate(!isEndDate);
    };
    var _useState3 = _sliced_to_array(useState(), 2), dayDataForSelectingCheckIn = _useState3[0], setDayDataForSelectingCheckIn = _useState3[1];
    var _useState4 = _sliced_to_array(useState(), 2), dayDataForSelectingCheckOut = _useState4[0], setDayDataForSelectingCheckOut = _useState4[1];
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, loading = _useQuery.loading;
    useEffect(function() {
        var _data_propertyAvailabilityCalendars;
        if ((data === null || data === void 0 ? void 0 : (_data_propertyAvailabilityCalendars = data.propertyAvailabilityCalendars) === null || _data_propertyAvailabilityCalendars === void 0 ? void 0 : _data_propertyAvailabilityCalendars[0]) && (!dayDataForSelectingCheckIn || checkInDateString && !(dayDataForSelectingCheckOut === null || dayDataForSelectingCheckOut === void 0 ? void 0 : dayDataForSelectingCheckOut[checkInDateString]))) {
            var listingAvailability = data.propertyAvailabilityCalendars[0];
            var configuration = listingAvailability.configuration;
            var _listingAvailability_days;
            var days = _to_consumable_array((_listingAvailability_days = listingAvailability.days) !== null && _listingAvailability_days !== void 0 ? _listingAvailability_days : []);
            var datelessDayData = parseAvailability({
                configuration: configuration,
                days: days
            });
            setDayDataForSelectingCheckIn(datelessDayData);
            if (checkInDateString) {
                setDayDataForSelectingCheckOut(function(prevCheckOutDayData) {
                    return _object_spread(_define_property({}, checkInDateString, parseAvailability({
                        configuration: configuration,
                        days: days,
                        checkInDate: checkInDateString
                    })), prevCheckOutDayData);
                });
            }
        }
    }, [
        data,
        checkInDateString,
        dayDataForSelectingCheckIn,
        dayDataForSelectingCheckOut
    ]);
    if (loading) {
        return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
            referrerId: "HOT.HIS:AvailabilityCalendar.loading",
            linkName: "Availability Calendar Loading"
        }, /* @__PURE__ */ React2.createElement(EGDSLayoutGrid, {
            columns: 2,
            space: "two"
        }, /* @__PURE__ */ React2.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */ React2.createElement(EGDSCard, {
            padded: true,
            border: true
        }, /* @__PURE__ */ React2.createElement(EGDSSpacing, {
            margin: {
                inlinestart: "one"
            }
        }, /* @__PURE__ */ React2.createElement(EGDSLineSkeleton, {
            animation: true,
            type: "secondary"
        })), /* @__PURE__ */ React2.createElement(EGDSSpacing, {
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React2.createElement(EGDSLineSkeleton, {
            animation: true,
            type: "primary"
        })))), /* @__PURE__ */ React2.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */ React2.createElement(EGDSCard, {
            padded: true,
            border: true
        }, /* @__PURE__ */ React2.createElement(EGDSSpacing, {
            margin: {
                inlinestart: "one"
            }
        }, /* @__PURE__ */ React2.createElement(EGDSLineSkeleton, {
            animation: true,
            type: "secondary"
        })), /* @__PURE__ */ React2.createElement(EGDSSpacing, {
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React2.createElement(EGDSLineSkeleton, {
            animation: true,
            type: "primary"
        }))))));
    }
    var dateless = !checkInDateString && !checkInDateString;
    var datedAndSelectingCheckIn = !dateless && currentlySelectingCheckInDate;
    var dayData = dateless || datedAndSelectingCheckIn ? dayDataForSelectingCheckIn : dayDataForSelectingCheckOut === null || dayDataForSelectingCheckOut === void 0 ? void 0 : dayDataForSelectingCheckOut[checkInDateString];
    var locale = context.locale.replace("_", "-");
    return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: "HOT.HIS:AvailabilityCalendar",
        linkName: "Availability Calendar"
    }, /* @__PURE__ */ React2.createElement(EGDSDateSelector, {
        dateFormatOptions: {
            month: "short",
            day: "numeric"
        },
        dayData: dayData,
        dayTemplateComponent: dayData ? PropertyAvailabilityDayTemplate : void 0,
        endDate: checkOutDateString,
        endDateRef: endDateRef,
        inputName1: "startDate",
        inputName2: "endDate",
        onOpen: onOpen,
        onClose: onClose,
        locale: locale,
        onDateRangeChange: onDateRangeChange,
        onDateRangeClear: onDateRangeClear,
        onSubmit: onDateRangeSubmit,
        onSelectionModeChange: onSelectionModeChange,
        startDate: checkInDateString,
        startDateRef: startDateRef,
        handleShape: "circle",
        navType: "inset",
        isNestDialog: isNestDialog,
        maxDate: maxDate ? new Date(maxDate) : void 0
    }));
};
PropertyAvailability.displayName = "sharedui-PropertyAvailability";
export { PropertyAvailability };
//# sourceMappingURL=index.js.map